/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/services/api';

export async function serviceListTypeNiche() {
  try {
    const response = await api.get<{ id: number; name: string }[]>('/type-niches');
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}

export async function serviceListTypeEvent() {
  try {
    const response = await api.get<{ id: number; name: string; active: boolean }[]>('/type-events');
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}

//update type event
export async function serviceUpdateTypeEvent({ id }: { id: number }) {
  try {
    const response = await api.put<{ id: number }>(`/type-events/${id}`);
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}

export async function serviceDeleteTypeNiche({ id }: { id: number }) {
  try {
    const response = await api.delete<{ id: number }>(`/type-niches/${id}`);
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
}
